import { render, staticRenderFns } from "./EditInfoModal.vue?vue&type=template&id=a2ea6236&scoped=true"
import script from "./EditInfoModal.vue?vue&type=script&lang=js"
export * from "./EditInfoModal.vue?vue&type=script&lang=js"
import style0 from "./EditInfoModal.vue?vue&type=style&index=0&id=a2ea6236&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2ea6236",
  null
  
)

export default component.exports